import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import 'leonardo-ui/dist/leonardo-ui.css';
import qDocPromise from 'config/qDoc';
// MUI
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

import Filter from 'components/Filter/Filter';
import Search from 'components/Search/Search';
import Table from 'components/Table/Table';
import DownloadReportButton from 'components/DownloadReportButton/DownloadReportButton';
// import DownloadForm from 'components/DownloadForm';
import Timeout from 'components/Timeout/Timeout';
import { UserContext } from '../../UserContext';


import styles from './styles';

class GenerateReportsAlt extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  }

  state = {
    qDocLoaded: false,
    searchString: '',
    selectedDate: null,
    selectedCurrency: null,
    reportType: 'Qlik New Customer Product Price List',
  }

  componentDidMount() {
    this.awaitQDoc();
  }

  setSearchString = (searchString) => {
    this.setState({ searchString });
  }

  setDateAndCurrency = async () => {
    const qDoc = await qDocPromise;
    const selectedDate = await qDoc.evaluateEx('only({<[Month Year]=P()>} [Month Year])');
    const selectedCurrency = await qDoc.evaluateEx('only({<[Currency]=P()>} Currency)');
    this.setState({ selectedDate: selectedDate.qText, selectedCurrency: selectedCurrency.qText });
  }

  awaitQDoc = async () => {
    const qDoc = await qDocPromise;

    this.setDateAndCurrency();
    const monthYearField = await qDoc.getField('[Month Year]');
    const currencyField = await qDoc.getField('[Currency]');
    monthYearField.on('changed', () => {
      this.setDateAndCurrency();
    });
    currencyField.on('changed', () => {
      this.setDateAndCurrency();
    });
    this.setState({ qDocLoaded: true });
  }


  // Radio Button Report Type
  handleChange = (e) => {
    this.setState({ reportType: e.target.value });
  };

  render() {
    const { classes } = this.props;
    const {
      qDocLoaded, searchString, selectedDate, selectedCurrency,
    } = this.state;

    // Need to bubbleUp selectedDate and selectedCurrency from Filter (put in Context)
    // const { searchString } = this.state;

    // if (!qDocLoaded || !selectedDate || !selectedCurrency) {
    //   return (
    //     <div
    //       style={{
    //         width: '100vw',
    //         height: '100px',
    //         display: 'flex',
    //         justifyContent: 'center',
    //         alignItems: 'center',
    //         fontSize: 28,
    //       }}
    //     >
    //       Loading...
    //     </div>
    //   );
    // }

    return (
      <div className={classes.generateReports}>
        <div className={classes.container}>
          {/* {!this.state.qDocLoaded && (
          <div style={{
            width: '100vw',
            height: '100px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: 28,
          }}
          >
            Loading...
          </div>
        )} */}

          {(!qDocLoaded || !selectedDate || !selectedCurrency) && (
            <div className={classes.overlay}>
              <div className={classes.loaderIcon} />
            </div>
          )}

          {this.state.qDocLoaded && (
            <UserContext.Consumer>
              {(userObject) => {
                const isPartner = (
                  userObject &&
                  userObject.user &&
                  userObject.user.level === 'partner'
                );

                return (

                  <div>
                    <Timeout />
                    <main className={classes.main}>
                      <section className={classes.intro}>
                        <div className={classes.introText}>
                          <p>
                            <strong>Welcome to Qlik’s Product Price List portal.</strong> Built on Qlik Sense®, you can access Qlik’s product pricing in 19 currencies. You can search for specific items or generate PDF copies of Qlik’s New Customer Product Price List or Qlik’s Full Product Price List.
                          </p>
                        </div>
                        <div className={classes.reportFromContainer}>
                          <div className={classes.reportTypeSelector}>
                            <FormControl>
                              <FormLabel id="demo-controlled-radio-buttons-group">Generate PDF Report for {selectedDate} (in {selectedCurrency}):</FormLabel>
                              <span className={classes.optionSelect}>Select an option</span>
                              <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={this.state.reportType}
                                onChange={this.handleChange}
                              >
                                <FormControlLabel value="Qlik New Customer Product Price List" control={<Radio />} label="New Customer Product Price List" />
                                <FormControlLabel value="Qlik Full Product Price List" control={<Radio />} label="Full Product Price List" />
                              </RadioGroup>
                            </FormControl>
                          </div>
                          <div>
                            {/* <button className={classes.btnFilled}>Request report</button> */}
                            <DownloadReportButton title={this.state.reportType} selectedCurrency={selectedCurrency || ''} selectedDate={selectedDate || ''} />
                          </div>
                        </div>
                      </section>


                      <section className={classes.topBar}>
                        <div className={classes.topBarSelects}>
                          <div className={classes.topBarSelect}>
                            <Filter titleShow={false} field="[Month Year]" title="Valid As Of" dropdown overrideLock />
                          </div>
                          <div className={classes.topBarSelect}>
                            <Filter titleShow={false} field="[Currency]" title="Currency" dropdown overrideLock />
                          </div>
                        </div>
                        {/* <div className={classes.topBarSearch}>
                          <Search searchString={searchString} setSearchString={this.setSearchString} />
                        </div> */}
                      </section>


                      <section className={classes.section}>
                        <div className={classes.tableAndFilters}>
                          <div className={classes.filtersContainer}>
                            <div className={classes.sidebarSearch}>
                              <Search searchString={searchString} setSearchString={this.setSearchString} />
                            </div>
                            <div className={classes.sideBarFilter}>
                              <Filter titleShow={false} field="[Matrix Sales Channel]" title="Sales Channel" toggleSelections />
                            </div>
                            <div className={classes.sideBarFilter}>
                              <Filter titleShow={false} field="[Matrix Deployment Model]" title="Deployment Model" toggleSelections />
                            </div>
                            <div className={classes.sideBarFilter}>
                              <Filter titleShow={false} field="[Matrix Product Category]" title="Product Category" toggleSelections />
                            </div>
                            <div className={classes.sideBarFilter}>
                              <Filter titleShow={false} field="[Matrix Product/Capacity]" title="Product/Capacity" toggleSelections />
                            </div>
                          </div>
                          <div className={classes.table}>
                            <Table searchString={searchString} selectedDate={selectedDate || ''} isPartner={isPartner} />
                          </div>
                        </div>
                      </section>

                      <section className={classes.footer}>
                        <p>Qlik’s Full Product Price List is the complete and official Price List. Qlik’s New Customer Product Price List is for net new deployments of Qlik Data Analytics solutions. Qlik’s policy for selling to net new deployments, direct or in-direct via partners are to be Subscription license only. Qlik Sales will find the latest Subscription and other policies in Confluence.<br />Qlik Product Price Lists are Qlik Confidential Information and are provided to partners solely for partner internal use in accordance with your confidentiality or partner agreement with Qlik. Redistribution in any manner of any Qlik Product Price List, in whole or in part, is prohibited.
                        </p>
                        <p>Closed Access: Product marked as ‘closed access’ requires the partner to obtain authorization from Qlik to participate and/or access, as applicable. Additional Product Partner Discount applies to designated Qlik Additional Products and any other products designated by Qlik. Program Incentives such as Sales Performance Discount, Deal Protection and New Logo Incentive Program expressly do not apply to Qlik Additional Products.
                        </p>
                        <p>Please note that the product specific searching below is provided for informational purposes only, and partners must review the full Qlik Product Full Price List for all terms and conditions related to Qlik Products. Additional product specifications are available in the License Metrics at www.qlik.com/license-terms.</p>
                      </section>

                    </main>
                  </div>

                );
              }}
            </UserContext.Consumer>
          )}
        </div>
      </div>
    );
  }
}

GenerateReportsAlt.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default injectSheet(styles)(GenerateReportsAlt);
